<template>
  <div class="container-new">
    <!-- ASIDE -->
    <Aside />
    <!-- ASIDE -->
    <!-- MAIN -->
    <main>
      <h1>Мои отчеты</h1>
      <!-- <div class="table-filter">
        <select
          v-model="filter.reportCompanyValue"
          class="t-filter-select-company"
          aria-placeholder="ewewe"
        >
          <option value="">Выберите компанию</option>
          <option
            v-for="company in this.allCompany"
            :key="company"
            :value="company"
          >
            {{ company }}
          </option>
        </select>
        <select
          v-model="filter.reportYearValue"
          class="t-filter-select-company"
          aria-placeholder="ewewe"
        >
          <option value="">Выберите год</option>
          <option v-for="year in this.allYear" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
        <select
          v-model="filter.reportMonthValue"
          class="t-filter-select-company"
          aria-placeholder="ewewe"
        >
          <option value="">Выберите месяц</option>
          <option v-for="month in this.allMonth" :key="month" :value="month">
            {{ month | getMonth }}
          </option>
        </select>
        <select
          v-model="filter.reportStatusValue"
          class="t-filter-select-company"
          aria-placeholder="ewewe"
        >
          <option value="">Статус</option>
          <option
            v-for="status in this.allStatus"
            :key="status"
            :value="status"
          >
            {{ status }}
          </option>
        </select>
        <button @click="changeReportsFilter()">
          Поиск
        </button>
      </div> -->

      <!-- Table -->
      <div class="table-container">
        <h2><span class="primary">Мои</span> отчеты</h2>
        <table>
          <thead>
            <tr>
              <th>№ п/п</th>
              <th>ДЗО</th>
              <th>Отчет создан</th>
              <th>Отчет утвержден</th>
              <th>Год</th>
              <th>Месяц</th>
              <th>Дата создания</th>
              <th>Статус</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(report, index) in this.reports"
              :key="report.id"
              @click="openReport(report.id)"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ report.dzo.name }}</td>
              <td>
                {{ report.create_user.first_name | TitleCase }}
                {{ report.create_user.last_name | TitleCase }}
              </td>
              <td>
                {{
                  report.approved_user
                    ? report.approved_user.first_name
                    : "" | TitleCase
                }}
                {{
                  report.approved_user
                    ? report.approved_user.last_name
                    : "-" | TitleCase
                }}
              </td>
              <td>{{ report.year }}</td>
              <td>{{ report.month | getMonth }}</td>
              <td>{{ report.created_datetime | formatDate }}</td>
              <td>
                <p class="my-report-status" :class="getBtnColor(report.status)">
                  {{ report.status }}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <a class="reveal-rows" href="#">Показать больше</a> -->
      </div>
      <!-- Table -->
    </main>
    <!-- MAIN -->

    <!-- Right Section -->
    <div class="right">
        <!-- top -->
        <div class="top">
          <button id="menu-btn" @click="openMenu">
            <span class="material-icons-sharp"> menu </span>
          </button>
          <!-- <div class="profile">
            <div class="info">
              <p>
                Здравствуйте, <b>{{ USER.first_name | TitleCase }}</b>
              </p>
              <small class="text-muted">{{
                USER.ouser.role[0].name | TitleCase
              }}</small>
            </div>
            <div class="profile-photo">
              <img src="@/assets/avatar.png" alt="Profile photo" />
            </div>
          </div> -->
        </div>
        <!-- top -->
        <!-- recent updates -->
        <div class="recent-updates">
          <h2>Лента</h2>
          <div class="updates">
            <!-- <div class="update">
              <div class="profile-photo">
                <img
                  src="https://via.placeholder.com/150"
                  alt="Profile photo"
                />
              </div>
              <div class="message">
                <p><b>Сериков Серик</b> обновил профиль</p>
                <small class="text-muted">2 Minutes ago</small>
              </div>
            </div>
            <div class="update">
              <div class="profile-photo">
                <img
                  src="https://via.placeholder.com/150"
                  alt="Profile photo"
                />
              </div>
              <div class="message">
                <p><b>Бериков Самат</b> обновил профиль</p>
                <small class="text-muted">2 Minutes ago</small>
              </div>
            </div>
            <div class="update">
              <div class="profile-photo">
                <img
                  src="https://via.placeholder.com/150"
                  alt="Profile photo"
                />
              </div>
              <div class="message">
                <p><b>Бериков Самат</b> создал отчет ТМЗ</p>
                <small class="text-muted">2 Minutes ago</small>
              </div>
            </div>
            <div class="update">
              <div class="profile-photo">
                <img
                  src="https://via.placeholder.com/150"
                  alt="Profile photo"
                />
              </div>
              <div class="message">
                <p><b>Бериков Самат</b> создал отчет ТМЗ</p>
                <small class="text-muted">2 Minutes ago</small>
              </div>
            </div> -->
          </div>
        </div>
        <!-- recent updates -->
        <!-- Sales -->
        <div class="analytics">
          <h2>Аналитика</h2>
          <div class="item online">
            <div class="icon">
              <span class="material-icons-sharp">dashboard</span>
            </div>
            <div class="item-right">
              <div class="info">
                <h3>Создано отчетов</h3>
                <small class="text-muted">За последние сутки</small>
              </div>
              <h5 class="success">+39%</h5>
              <h3>3849</h3>
            </div>
          </div>
          <div class="item offline">
            <div class="icon">
              <span class="material-icons-sharp">dashboard</span>
            </div>
            <div class="item-right">
              <div class="info">
                <h3>Подписано отчетов</h3>
                <small class="text-muted">За последние сутки</small>
              </div>
              <h5 class="success">+39%</h5>
              <h3>3849</h3>
            </div>
          </div>
          <div class="item customers">
            <div class="icon">
              <span class="material-icons-sharp">dashboard</span>
            </div>
            <div class="item-right">
              <div class="info">
                <h3>Новые пользователи</h3>
                <small class="text-muted">За последние сутки</small>
              </div>
              <h5 class="success">+25%</h5>
              <h3>3849</h3>
            </div>
          </div>
          <div class="item add-product">
            <div>
              <span class="material-icons-sharp">add</span>
              <h3>Создать отчет</h3>
            </div>
          </div>
        </div>
        <!-- Sales -->
      </div>
    <!-- Right Section -->
  </div>
</template>

<script>
import Aside from "@/components/Aside";
import { mapGetters } from "vuex";
import { isImpl, isRecipient, isApproved } from "@/variables";
import { month_options } from "@/variables";

export default {
  components: {
    Aside,
  },
  data() {
    return {
      isImpl: false,
      isRecipient: false,
      isApproved: false,
      select_month: "",
      reports: [],
      allReports: [],
      months: "",
      allCompany: "",
      allYear: "",
      allMonth: "",
      allStatus: "",
      filter: {
        reportCompanyValue: "",
        reportStatusValue: "",
        reportYearValue: "",
        reportMonthValue: "",
      },
    };
  },
  created() {
    this.months = month_options;
  },
  methods: {
    closeMenu: () => {
      const menu = document.querySelector("aside");
      menu.style.display = "none";
    },
    openMenu: () => {
      const menu = document.querySelector("aside");
      menu.style.display = "block";
    },
    downloadExcelMonth() {
      let formData = {
        reportId: this.$route.params.id,
        month: this.select_month,
      };
      this.$store.dispatch("downLoadExcel", formData);
    },
    getAllReports() {
      this.$store.dispatch("getAllReports").then((response) => {
        this.reports = response;
        this.allReports = response;
        this.initializeSet(response);
      });
      this.$store.dispatch("addNotification", {
        type: "success",
        message: "Мои отчеты обновлены",
      });
    },
    openReport(id) {
      this.$router.push({ name: "view-report-item", params: { id: id } });
    },
    // deleteAllReport() {
    //   this.$store.dispatch('deleteAllReport');
    // },
    getBtnColor(status) {
      let color = "";
      if (status === "Создан") {
        color = "status-green";
      } else if (status === "Подписан исполнителем") {
        color = "status-yellow";
      } else if (status === "Подписан утверждающим") {
        color = "status-yellow";
      } else if (status === "Редактирован") {
        color = "status-yellow";
      } else if (status === "Авто-изменения после корректировки") {
        color = "status-yellow";
      } else if (status === "Утвержден получателем КМГ") {
        color = "status-blue";
      } else if (status === "Отклонен утверждающим") {
        color = "status-red";
      } else if (status === "Отклонен получателем КМГ") {
        color = "status-red";
      }
      return color;
    },
    initializeSet(reports) {
      var mySetCompany = new Set();
      var mySetStatus = new Set();
      var mySetYear = new Set();
      var mySetMonth = new Set();
      for (let i = 0; i < reports.length; ++i) {
        mySetCompany.add(reports[i].dzo.name);
        mySetStatus.add(reports[i].status);
        mySetYear.add(reports[i].year);
        mySetMonth.add(reports[i].month);
      }
      this.allCompany = mySetCompany;
      this.allStatus = mySetStatus;
      this.allYear = mySetYear;
      this.allMonth = mySetMonth;
    },
    changeReportsFilter() {
      var status = this.filter.reportStatusValue;
      var company = this.filter.reportCompanyValue;
      var year = this.filter.reportYearValue;
      var month = this.filter.reportMonthValue;
      if (company || status || month || year) {
        this.reports = this.allReports.filter(function (report) {
          return (
            (status ? report.status === status : true) &&
            (company ? report.dzo.name === company : true) &&
            (month ? report.month === month : true) &&
            (year ? report.year === year : true)
          );
        });
      } else {
        this.reports = this.allReports;
      }
    },
  },

  mounted() {
    this.getAllReports();
    this.isImpl = isImpl(this.USER.ouser);
    this.isRecipient = isRecipient(this.USER.ouser);
    this.isApproved = isApproved(this.USER.ouser);
  },
  computed: {
    ...mapGetters(["REPORTS", "ALLDZO", "USER"]),
  },
};
</script>

<style scoped>
.container-new {
  display: grid;
  width: 96%;
  margin: 0 auto;
  gap: 1.8rem;
  grid-template-columns: 14rem auto 23rem;
}

.table-filter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.table-filter select {
  padding: 1rem;
  margin: 0rem 1rem;
  max-width: 12.5rem;
  min-width: 12.5rem;
  border-radius: var(--border-radius-2);
  text-align: center;
  background: var(--color-white);
  color: var(--color-dark);
  box-shadow: var(--box-shadow);
  /* border: 1px solid var(--color-dark); */
}

.table-filter button {
  padding: var(--padding-1) 2.5rem;
  border-radius: var(--border-radius-2);
  background: var(--color-dark);
  color: var(--color-white);
  cursor: pointer;
}

.table-filter button i::before {
  /* font-size: 1.2rem; */
}

@media screen and (max-width: 1200px) {
  .container-new {
    width: 94%;
    grid-template-columns: 7rem auto;
  }


  main {
    grid-template-columns: 1fr;
    gap: 0;
  }

  main .table-filter {
    width: auto;
  }

  main .table-container {
    width: 94%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin: 2rem 0 0 8.8rem;
  }

  main .table-container table {
    width: 83vw;
  }
}
</style>
